import { render, staticRenderFns } from "./reviseTask.vue?vue&type=template&id=759a2e72&scoped=true&"
import script from "./reviseTask.vue?vue&type=script&lang=js&"
export * from "./reviseTask.vue?vue&type=script&lang=js&"
import style0 from "./reviseTask.vue?vue&type=style&index=0&id=759a2e72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "759a2e72",
  null
  
)

export default component.exports